module.exports = __webpack_public_path__ + "static/media/green_car.77426fe4.png";